var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1758 0.351562V14.3516",
    stroke: "#B3B3B3",
    strokeWidth: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1758 7.35156L0.17578 7.35156",
    stroke: "#B3B3B3",
    strokeWidth: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3516 1.35131C23.3516 0.702085 22.8253 0.175781 22.176 0.175781H1.17603C0.526802 0.175781 0.000499725 0.702085 0.000499725 1.35131V13.3513C0.000499725 14.0005 0.526802 14.5268 1.17603 14.5268H22.176C22.8253 14.5268 23.3516 14.0005 23.3516 13.3513V1.35131ZM22.176 0.526845C22.6314 0.526845 23.0005 0.895972 23.0005 1.35131V13.3513C23.0005 13.8067 22.6314 14.1758 22.176 14.1758H1.17603C0.72069 14.1758 0.351562 13.8067 0.351562 13.3513V1.35131C0.351562 0.895972 0.72069 0.526845 1.17603 0.526845H22.176Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.6C6 4.26863 6.26863 4 6.6 4L17.4 4C17.7314 4 18 4.26863 18 4.6L18 10.4C18 10.7314 17.7314 11 17.4 11L6.6 11C6.26863 11 6 10.7314 6 10.4L6 4.6Z",
    fill: "#201CE0",
    stroke: "black",
    strokeWidth: 0.349105
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.d0f73e1681e3263c326ff44a8630e11c.svg";
export { ForwardRef as ReactComponent };